export default __webpack_public_path__ + "media/components/SliderWithContent/default-d170e1108c0432141f7c5c731e28a8b0.jpg";